var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ManageUser } from "../constants/manage_users";
import { Status } from "../constants/status";
var initialState = {
    manageUserState: ManageUser.ManageUser,
    manageExportUsers: "",
    manageArchiveUsers: "",
    manageDeleteUsers: null,
};
function getShortDate(date) {
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    var day = date.getDate().toString().padStart(2, "0");
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    return "".concat(day, " ").concat(month, " ").concat(year);
}
function parseStats(data) {
    var jobseekers = parseJobseekers(data);
    var predictionSum = 0, predictionCount = 0;
    var q1Sum = 0, q1Count = 0;
    var q2Sum = 0, q2Count = 0;
    var time_gap_sum = 0, time_gap_count = 0;
    // Employment stats
    var numEmployed = 0, num_self_employed = 0, num_modern_apprenticeship = 0;
    var num_further_education = 0, num_higher_education = 0, num_school = 0;
    var total_jobseekers = jobseekers.length;
    jobseekers.forEach(function (js) {
        // Prediction
        if (typeof js.blr_score === "number") {
            predictionSum += js.blr_score;
            predictionCount++;
        }
        else if (typeof js.blr_score === "string" && js.blr_score.endsWith("%")) {
            var num = parseFloat(js.blr_score.replace("%", ""));
            if (!isNaN(num)) {
                predictionSum += num;
                predictionCount++;
            }
        }
        // Employment
        if (typeof js.employed === "string") {
            if (js.employed === "Yes") {
                numEmployed++;
            }
        }
        if (typeof js.self_employed === "string") {
            if (js.self_employed === "Yes") {
                num_self_employed++;
            }
        }
        if (typeof js.modern_apprenticeship === "string") {
            if (js.modern_apprenticeship === "Yes") {
                num_modern_apprenticeship++;
            }
        }
        if (typeof js.further_education === "string") {
            if (js.further_education === "Yes") {
                num_further_education++;
            }
        }
        if (typeof js.higher_education === "string") {
            if (js.higher_education === "Yes") {
                num_higher_education++;
            }
        }
        if (typeof js.school === "string") {
            if (js.school === "Yes") {
                num_school++;
            }
        }
        // Q1
        if (typeof js.wellbeing_score_q1 === "number") {
            q1Sum += js.wellbeing_score_q1;
            q1Count++;
        }
        // Q2
        if (typeof js.wellbeing_score_q2 === "number") {
            q2Sum += js.wellbeing_score_q2;
            q2Count++;
        }
        // Time gap
        if (typeof js.timegap === "number" && js.timegap > 0) {
            time_gap_sum += js.timegap;
            time_gap_count++;
        }
    });
    var avg_prediction = predictionCount > 0 ? (predictionSum / predictionCount).toFixed(2) : 0;
    var avg_q1 = q1Count > 0 ? (q1Sum / q1Count).toFixed(2) : 0;
    var avg_q2 = q2Count > 0 ? (q2Sum / q2Count).toFixed(2) : 0;
    var time_gap_avg = time_gap_count > 0 ? (time_gap_sum / time_gap_count).toFixed(1) : 0;
    var jobseekerStatsTiles = [
        {
            title: "Customer Stats",
            points: [
                "Total Customers: ".concat(total_jobseekers || "0"),
                "Prediction Avg: ".concat(avg_prediction.toString(), "%") || "0%",
            ],
            status: Status.Successful,
        },
        {
            title: "Summary",
            points: [
                "Q1 Attempted: ".concat(q1Count, "/").concat(total_jobseekers || "0"),
                "Q2 Attempted: ".concat(q2Count, "/").concat(total_jobseekers || "0"),
                "Time Gap Avg: ".concat(time_gap_avg.toString() || " - ", " Days"),
            ],
            status: Status.Successful,
        },
        {
            title: "Wellbeing",
            points: ["Wellbeing Q1 Avg: ".concat(avg_q1.toString() || " - "), "Wellbeing Q2 Avg: ".concat(avg_q2.toString() || " - "),
            ],
            status: Status.Successful,
        },
        {
            title: "Employment Details",
            points: [
                "Employed: ".concat(numEmployed.toString() || "0"),
                "Self-Employed: ".concat(num_self_employed.toString() || "0"),
                "Modern Apprenticeship: ".concat(num_modern_apprenticeship.toString() || "0"),
            ],
            status: Status.Successful,
        },
        {
            title: "Education",
            points: [
                "Further Education: ".concat(num_further_education.toString() || "0"),
                "Higher Education: ".concat(num_higher_education.toString() || "0"),
                "School: ".concat(num_school.toString() || "0"),
            ],
            status: Status.Successful,
        }
    ];
    return jobseekerStatsTiles;
}
function parseJobseekers(data) {
    var result = [];
    Object.keys(data["jobseekers"]).forEach(function (name) {
        var current = data["jobseekers"][name];
        var date = new Date(current["date_joined"]);
        var shortdate = getShortDate(date);
        var blr;
        if (current["blr_score"] < 1) {
            if (current["prediction_reason"]) {
                blr = current["prediction_reason"];
            }
            else if (current["questionnaire_1_date"] === "") {
                blr = "No questionnaire data";
            }
            else if (current["questionnaire_2_date"] === "") {
                blr = "Needs 2nd questionnaire";
            }
            else {
                blr = "Insufficient data";
            }
        }
        else {
            blr = current["blr_score"].toString() + "%";
        }
        // The progression milestone attempt is optional and adviser-triggered -
        // only count it towards the total once the adviser has enabled it for
        // this jobseeker, so an untouched existing user still sees "x / 2".
        var milestoneReady = !!current["milestone_questionnaire_ready"];
        var attemptsTotal = milestoneReady ? 3 : 2;
        var count = 0;
        if (current["questionnaire_1_date"] !== "") {
            count += 1;
        }
        if (milestoneReady && current["questionnaire_milestone_date"] !== "") {
            count += 1;
        }
        if (current["questionnaire_2_date"] !== "") {
            count += 1;
        }
        var diff = 0;
        var lastDate = current["questionnaire_2_date"] ||
            (milestoneReady ? current["questionnaire_milestone_date"] : "") ||
            "";
        if (current["questionnaire_1_date"] !== "" && lastDate !== "") {
            var q1Date = new Date(current["questionnaire_1_date"]);
            var finalDate = new Date(lastDate);
            var timeDiff = Math.abs(finalDate.getTime() - q1Date.getTime());
            diff = Math.max(1, Math.floor(timeDiff / (1000 * 60 * 60 * 24)));
        }
        result.push({
            name: name,
            dateJoined: shortdate,
            questionnaire_attempts: count,
            questionnaire_attempts_total: attemptsTotal,
            blr_score: blr,
            timegap: diff,
            employed: current["employed"] || "-",
            self_employed: current["self_employed"] || "-",
            modern_apprenticeship: current["modern_apprenticeship"] || "-",
            further_education: current["further_education"] || "-",
            higher_education: current["higher_education"] || "-",
            school: current["school"] || "-",
            wellbeing_score_q1: current["wellbeing_score_q1"] !== undefined
                ? current["wellbeing_score_q1"]
                : null,
            wellbeing_score_q2: current["wellbeing_score_q2"] !== undefined
                ? current["wellbeing_score_q2"]
                : null,
            prediction_reason: current["prediction_reason"] || "",
        });
    });
    return result;
}
function parseAdvisers(data) {
    var result = [];
    Object.keys(data["advisers"]).forEach(function (name) {
        var current = data["advisers"][name];
        var date = new Date(current["date_joined"]);
        var shortdate = getShortDate(date);
        result.push({
            name: name,
            dateJoined: shortdate,
            caseload: current["caseload_count"].toString(),
        });
    });
    return result;
}
function parseManagers(data) {
    var result = [];
    Object.keys(data["managers"]).forEach(function (name) {
        var current = data["managers"][name];
        var date = new Date(current["date_joined"]);
        var shortdate = getShortDate(date);
        result.push({
            name: name,
            dateJoined: shortdate,
            adviser_number: current["adviser_count"],
            caseload: current["caseload_count"],
        });
    });
    return result;
}
function parseOrganisations(data) {
    var organisations = [];
    if (data.organisations) {
        Object.keys(data.organisations).forEach(function (org) {
            var date = new Date(data.organisations[org].date_joined);
            var shortdate = getShortDate(date);
            organisations.push({
                name: org,
                dateJoined: shortdate,
                manager_number: data.organisations[org].manager_count,
                adviser_number: data.organisations[org].adviser_count,
                caseload: data.organisations[org].caseload_count,
            });
        });
    }
    return organisations;
}
function parseCaseload(data) {
    var parsedData = {};
    // Always include team_members if present in the response
    if (data.team_members) {
        parsedData.team_members = data.team_members;
    }
    switch (data.user_type) {
        case "superorg":
            parsedData.organisations = parseOrganisations(data);
            parsedData.managers = parseManagers(data);
            parsedData.advisers = parseAdvisers(data);
            parsedData.jobseekers = parseJobseekers(data);
            return parsedData;
        case "organisation":
            parsedData.managers = parseManagers(data);
            parsedData.advisers = parseAdvisers(data);
            parsedData.jobseekers = parseJobseekers(data);
            return parsedData;
        case "manager":
            parsedData.advisers = parseAdvisers(data);
            parsedData.jobseekers = parseJobseekers(data);
            return parsedData;
        case "adviser":
            parsedData.jobseekers = parseJobseekers(data);
            return parsedData;
        default:
            return parsedData;
    }
}
var ManageUserReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ManageUser.ManageUser:
            return __assign(__assign({}, state), { children: undefined, status: Status.Loading });
        case ManageUser.ManageUser_Sucessful:
            return __assign(__assign({}, state), { status: Status.Successful, caseload: parseCaseload(action.payload), stats: parseStats(action.payload), manageArchiveUsers: "", manageDeleteUsers: null });
        case ManageUser.ManageUser_Error:
            return __assign(__assign({}, state), { status: Status.Error });
        case ManageUser.ManageUserDashboard:
            return __assign(__assign({}, state), { status: Status.Loading });
        case ManageUser.ManageUserDashboard_Sucessful:
            return __assign(__assign({}, state), { status: Status.Successful });
        case ManageUser.ManageUserDashboard_Empty:
            return __assign(__assign({}, state), { status: Status.Successful });
        case ManageUser.ManageUserDashboard_Error:
            return __assign(__assign({}, state), { status: Status.Error });
        case ManageUser.ManageExportUsers:
            return __assign(__assign({}, state), { status: Status.Loading });
        case ManageUser.ManageExportUsers_Sucessful:
            return __assign(__assign({}, state), { manageExportUsers: action.payload, status: Status.Successful });
        case ManageUser.ManageArchiveUsers:
            return __assign(__assign({}, state), { status: Status.Loading });
        case ManageUser.ManageArchiveUsers_Sucessful:
            return __assign(__assign({}, state), { manageArchiveUsers: action.payload, status: Status.Successful });
        case ManageUser.ManageDeleteUsers:
            return __assign(__assign({}, state), { status: Status.Loading });
        case ManageUser.ManageDeleteUsers_Sucessful:
            return __assign(__assign({}, state), { manageDeleteUsers: action.payload, status: Status.Successful });
        case ManageUser.ManageCreateUser_Successful:
            return __assign(__assign({}, state), { createUserStatus: { status: Status.Successful } });
        case ManageUser.ManageCreateUser_Error:
            return __assign(__assign({}, state), { createUserStatus: { status: Status.Error, message: action.payload } });
        case ManageUser.ManageCreateUser:
            return __assign(__assign({}, state), { createUserStatus: { status: Status.Loading } });
        default:
            return state;
    }
};
export default ManageUserReducer;
